import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';
import {COLORS} from '@/utils/constants';

const transformData = [
    {
        name: 'Yes',
        color: COLORS.e4ImpactBlue
    },
    {
        name: 'No',
        color: COLORS.e4ImpactOrange
    }
];

/**
 * Survey: PROJECT - FINAL IMPACT
 * Question: Have you opened any new sales channels during the year?
 * 
 * == final
 * sale_channels_t1
 * 
 * @param props
 * @returns 
 */
export const entrepreneursThatOpenedNewSalesChannelsChartCalculation = (props: any) => {
    const data = transformData.map(({name, color}) => ({
        name,
        color,
        y: props.finalSubmissions.filter((submission: any) => submission.sale_channels_t1 === name).length
    }));
    const values = transformData.map(({name}) => name);

    return getDefaultPieFormatting(
        '% of entrepreneurs that opened new sales channels',
        data,
        0,
        {},
    ) as Highcharts.Options;
}